module.exports = __webpack_public_path__ + "img/people_img_2_2.e2e2e993.png";